import platforms from "@/data/platforms-data";
import { getPlatforms } from "@/services/platform-service";
import { Platform } from "@/types/PlatformType";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import ms from 'ms';

const usePlatforms = () => {
    return useQuery<Platform[], Error>({
        queryKey: ["platforms"],
        queryFn: getPlatforms,
        placeholderData: keepPreviousData,
        initialData: platforms as Platform[],
        staleTime: ms('24h')
    });
};

export default usePlatforms;
